import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="nosotros" className="about">
      <div className="about-container">
        <div className="section-header">
          <h2 className="section-title">Sobre Innexia</h2>
          <p className="section-subtitle">
            Innovación Exponencial con Inteligencia Artificial
          </p>
        </div>

        <div className="about-content">
          <div className="about-card">
            <div className="about-icon">🎯</div>
            <h3 className="about-card-title">Visión</h3>
            <p className="about-card-description">
              Ser líderes en IA Generativa en Latinoamérica.
            </p>
          </div>

          <div className="about-card">
            <div className="about-icon">🚀</div>
            <h3 className="about-card-title">Misión</h3>
            <p className="about-card-description">
              Impulsar proyectos innovadores con soluciones accesibles y escalables.
            </p>
          </div>

          <div className="about-card">
            <div className="about-icon">💎</div>
            <h3 className="about-card-title">Valores</h3>
            <ul className="about-values">
              <li>Innovación continua</li>
              <li>Empoderamiento emprendedor</li>
              <li>Tecnología con propósito</li>
              <li>Transparencia y ética</li>
              <li>Colaboración y comunidad</li>
              <li>Excelencia técnica</li>
              <li>Adaptabilidad y evolución continua</li>
            </ul>
          </div>
        </div>

        <div className="about-commitment">
          <h3 className="commitment-title">Nuestro Compromiso</h3>
          <p className="commitment-text">
            En Innexia no solo desarrollamos soluciones: caminamos contigo en cada paso. 
            Desde la idea inicial hasta la implementación y más allá, nuestro equipo te 
            acompaña al 100%, asegurando que cada etapa de tu proyecto se convierta en una 
            experiencia única y transformadora. Porque para nosotros no basta con cumplir: 
            nos mueve superar cualquier expectativa y brindarte un valor que marque la diferencia.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;

